import { gql } from '@apollo/client';

export const MUTATION_ADD_FAVORITE = gql`
  mutation addFavorite($data: FavoriteInput!) {
    createFavorite(data: $data) {
      data {
        attributes {
          createdAt
        }
      }
    }
  }
`;

export const MUTATION_DELETE_FAVORITE = gql`
  mutation deleteFavorite($id: ID!) {
    deleteFavorite(id: $id) {
      data {
        attributes {
          createdAt
        }
      }
    }
  }
`;
